import React from 'react';

export const ScrollDownElement = () => {
  return (
    <a href='#connectWithMe' className='flex items-center justify-center h-16'>
      <div className='animate-bounce'>
        <span className='w-5 h-5 block rotate-45 animate-[animate_2s_infinite] -m-2.5 border-r-2 border-r-black border-b-2 border-b-black border-solid'></span>
        <span className='w-5 h-5 block rotate-45 animate-[animate_4s_infinite] -m-2.5 border-r-2 border-r-black border-b-2 border-b-black border-solid'></span>
        <span className='w-5 h-5 block rotate-45 animate-[animate_2s_infinite] -m-2.5 border-r-2 border-r-black border-b-2 border-b-black border-solid'></span>
      </div>
    </a>
  );
};
